<template>
    <div>
        <v-container
            fluid
            grid-list-md
        >
            <v-flex xs12>
                <h3 style="text-align:center">Lavanderias</h3>
            </v-flex>
            <v-layout row wrap>
                <v-flex
                    v-for="card in cards"
                    :key="card.title"
                    v-bind="{ [`xs${card.flex}`]: true }"
                >
                    <v-card>
                    <v-img
                        :src="card.src"
                        height="200px"
                    >
                        <v-container
                        fill-height
                        fluid
                        pa-2
                        >
                        <v-layout fill-height>
                            <v-flex xs12 align-end flexbox>
                            <span class="headline white--text" v-text="card.title"></span>
                            </v-flex>
                        </v-layout>
                        </v-container>
                    </v-img>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="goprofilecompany">
                            <v-icon>far fa-id-card</v-icon>
                        </v-btn>
                        <v-menu :close-on-content-click="false">
                            <v-btn icon slot="activator">
                                <v-icon>more_vert</v-icon>
                            </v-btn>
                            <v-list>
                                <v-list-tile>
                                    <v-list-tile-content style="cursor: pointer">
                                        <v-list-tile-title class="fas fa-comment"> chat</v-list-tile-title>
                                    </v-list-tile-content>  
                                </v-list-tile>  
                                <v-list-tile>
                                    <v-list-tile-content style="cursor: pointer">
                                        <v-list-tile-title class="fas fa-location-arrow"> Geolocalización</v-list-tile-title>
                                    </v-list-tile-content>
                                    
                                </v-list-tile>  
                            </v-list>
                        </v-menu>
                    </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
  export default {
    data: () => ({
      cards: [
        
        { title: 'Favorite road trips', src: 'https://cdn.vuetifyjs.com/images/cards/road.jpg', flex: 6 },
        { title: 'Best airlines', src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg', flex: 6 },
        { title: 'Best airlines', src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg', flex: 6 },
        { title: 'Best airlines', src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg', flex: 6 },
        { title: 'Best airlines', src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg', flex: 6 },
        { title: 'Best airlines', src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg', flex: 6 }
      ]
    }),
    props:{
        
    },
    methods:{
         goprofilecompany(){
            this.$router.push('/empresa')
        }
    }
  }
</script>